import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Constants from "../AppConstants/Constants";
import Layout from "../Layouts/LayoutMain";
import { PageTitle } from "../Components/Common/PageTitle";
import { ContentContainer } from "../Components/Common/ContentContainer";
import { SpecLoader } from "../Components/Loaders/Loaders";
import { getDevices } from "../Store/Catalog/Actions";

class DeviceComparison extends Component {
    constructor(props) {
        super(props);

        this.state= {
            specTitles: props.devices.length > 0 ? _.map(props.devices[0].productSpecifications, spec => spec.specificationAttributeName) : [],
            // changed this to 2 since we are filtering out samsung devices, change code back if we compare all devices
            // numberOfDevices: props.devices.length
            numberOfDevices: 2
        };

        this.renderImages = this.renderImages.bind(this);
        this.renderSpecRows = this.renderSpecRows.bind(this);
        this.renderButtons = this.renderButtons.bind(this);
        this.showDetails = this.showDetails.bind(this);
    }

    componentWillMount() {
        const { getDevices, devices, config: { DEVICES_CATEGORY_ID }, i18n, activeCurrency } = this.props;

        if (!devices || devices.length === 0 || devices[0].locale !== i18n.locale || devices[0].currencyCode !== activeCurrency.currencyCode) {
            getDevices(DEVICES_CATEGORY_ID, true, true, true);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { devices } = this.props;
        const { devices: nextDevices } = nextProps;

        if (nextDevices !== devices && nextDevices && nextDevices.length > 0 && nextDevices[0].productSpecifications) {

            // This filter only allows the panasonic and zebra device to be compared, if this ever changes comment out this code and replace all references to "filteredDevices" with "nextDevices".
            let filteredDevices = [];
            _.each(nextDevices, device => {
                if (device.sku === "FZ-N1EBJZZKM" || device.sku === "TC77HL-5ME24BG-NA") {
                    filteredDevices.push(device);
                }
            });
            // end

            const specTitles = _.map(filteredDevices[0].productSpecifications, spec => spec.specificationAttributeName);
            this.setState({ specTitles, numberOfDevices: filteredDevices.length });
        }
    }

    renderImages(devices) {
        const { numberOfDevices } = this.state;

        return (
            <div className="col-12 col-md-10 offset-md-2">
                <div className="row">
                    {_.map(devices, device => {
                        return (
                            <div key={device.id} className={`col-${parseInt(12 / numberOfDevices)} col-sm-${parseInt(12 / numberOfDevices)}`}>
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <img src={device.defaultPictureModel.fullSizeImageUrl} alt="Device"/>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    renderSpecRows(devices) {
        const { specTitles, numberOfDevices } = this.state;

        return _.map(specTitles, (title, titleIndex) =>
            <div key={title} className="row specRow">
                <div className="col-md-2 specTitle">
                    {/* Dont show the word Device in the first row, per the design, device name row has different styling */}
                    {title.replace(I18n.t("misc.device"), "")}
                </div>
                <div className="col-12 col-md-10">
                    <div className="row specDesc">
                        {_.map(devices, (device, deviceIndex) => {
                            const spec = _.find(device.productSpecifications, s => s.specificationAttributeName === title);
                            // unique key using device index and title index to prevent error from duplicate keys
                            const specKey = deviceIndex + "_" + titleIndex;

                            // handles a null spec attribute from admin
                            if (spec) {
                                const specDesc = spec.valueRaw.replace(/&quot;/g, "\"");
                                return (
                                    <div key={specKey} className={`col-${parseInt(12 / numberOfDevices)} col-sm-${parseInt(12 / numberOfDevices)}`}>
                                        <div className="row">
                                            <div className="col-12 col-md-12">
                                                {specDesc}
                                            </div>
                                        </div>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={specKey} className={`col-${parseInt(12 / numberOfDevices)} col-sm-${parseInt(12 / numberOfDevices)}`}>
                                        <div className="row">
                                            <div className="col-12 col-md-12">N/A</div>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                    </div>
                </div>
            </div>
        );
    }

    renderButtons(devices) {
        const { numberOfDevices } = this.state;

        return (
            <div className="col-12 col-md-10 offset-md-2">
                <div className="row">
                    {_.map(devices, device => {
                        return (
                            <div key={device.id} className={`col-${parseInt(12 / numberOfDevices)} col-sm-${parseInt(12 / numberOfDevices)}`}>
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <button type="button" className="btn btn--primary" onClick={() => {
                                            this.showDetails();
                                        }}><Translate value="misc.buyNow" /></button>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    //showDetails(data, qty) {
    //    this.props.history.push(`${Constants.ENDPOINTS.DEVICES_DETAILS}?product=${data.id}&quantity=${qty}`);
    //}

    //Above commented out and below added to prevent user from getting around adding wireless plan

    showDetails() {
        this.props.history.push(`${Constants.ENDPOINTS.DEVICES}`);
    }

    render() {
        const { devices } = this.props;

        // This filter only allows the panasonic and zebra device to be compared, if this ever changes comment out this code and replace all references to "filteredDevices" with just "devices" prop below.
        let filteredDevices = [];
        _.each(devices, device => {
            if (device.sku === "FZ-N1EBJZZKM" || device.sku === "TC77HL-5ME24BG-NA") {
                filteredDevices.push(device);
            }
        });
        // end

        return (
            <Layout isAuthenticated={this.props.isAuthenticated}>
                <PageTitle title="deviceComparison.title"/>
                <ContentContainer>
                    <div className="device-comparison-container">
                        <div className="row device-images">
                            {this.renderImages(filteredDevices)}
                        </div>
                        {!filteredDevices || !filteredDevices[0] || filteredDevices[0].productSpecifications.length === 0
                            ? <div className="specs-container">
                                <SpecLoader/>
                            </div>
                            : <div className="specs-container">
                                {this.renderSpecRows(filteredDevices)}
                            </div>
                        }
                        <div className="row buy-now-buttons">
                            {this.renderButtons(filteredDevices)}
                        </div>
                    </div>
                </ContentContainer>
            </Layout>
        )
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        activeCurrency: state.activeCurrency,
        config: state.config,
        devices: state.devices
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDevices: getDevices
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceComparison);